import React from "react";
import { Box, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import "@fontsource/prompt";



const TKSMemberCard = ({ member }) => {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 600,
                mx: 'auto',
                overflow: "hidden",
                fontFamily: "Prompt, sans-serif",
                boxShadow: 3,
                background: "linear-gradient(to bottom right, #fff2cc, #fff9e9)",
                position: "relative",
            }}
        >
            {/* Top Header with curve */}
            <Box
                sx={{
                    position: "relative",
                    background: "linear-gradient(to right, #fceabb, #f8b500)",
                    minHeight: 90,
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "flex-start" },
                    px: 2,
                    py: { xs: 2, sm: 0 },
                    gap: { xs: 1, sm: 2 }
                }}
            >
                <img
                    src="/CWA_logo.png"
                    alt="Logo"
                    style={{
                        height: 55,
                        width: "auto"
                    }}
                />
                <Typography
                    variant="h6"
                    sx={{
                        flex: 1,
                        textAlign: "center",
                        fontWeight: 600,
                        color: "red",
                        fontFamily: "Prompt, sans-serif",
                        fontSize: { xs: 16, sm: 18 }
                    }}
                >
                    திருக்கடையூர் சேனைத்தலைவர் அறக்கட்டளை
                    {/* Subtext below title */}
                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            fontWeight: 400,
                            fontSize: { xs: "0.45rem", sm: "0.5rem" },
                            color: "#333",
                            mt: 0.5
                        }}
                    >
                        Unique Registration Number: AAFTTI126RF20251
                        <br /> (Provisionally approved u/s 80G(5)(vi) of Income Tax Act, 1961)
                    </Typography>
                </Typography>
            </Box>

            {/* Direct Content on background */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "center",
                    px: 4,
                    py: 5,
                    gap: 2,
                }}
            >
                <Box sx={{ textAlign: "left", flex: 1 }}>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        NAME : {member.First_Name} {member.Last_Name}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        MEMBER ID : {member.id}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        DISTRICT : {member.District}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        LOCATION : {member.City}
                    </Typography>
                </Box>

                <Box sx={{ ml: 2, flexShrink: 0 }}>
                    <QRCodeCanvas
                        value={`TKS Member ID: ${member.id}\nName: ${member.First_Name} ${member.Last_Name}\nDistrict: ${member.District}\nLocation: ${member.City}\nMobile Number: ${member.Mobile_Number}`}
                        size={110}
                        bgColor="transparent"
                        fgColor="#000000"
                        level="L"
                        marginSize={-9}
                        imageSettings={{
                            src: "/CWA_logo.png",
                            height: 20,
                            width: 20,
                            opacity: 1.1,
                            excavate: true,
                        }}
                    />
                </Box>
            </Box>

            {/* Bottom bar with shallow notch */}
            {/* Bottom Bar */}
            <Box
                sx={{
                    height: "250",
                    background: "linear-gradient(to right, #e21818, #ffe600)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 3,
                    py: 1.5,
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 2,
                    //borderBottomRightRadius: "8px",
                    boxShadow: "0 6px 8px rgba(0, 0, 0, 0.1)",
                }}
            >
                {/* Left side text */}
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        color: "#ffff",
                        textAlign: { xs: "center", sm: "left" },
                        mb: { xs: 2, sm: 0 }
                    }}
                >
                    TKS Trust, Project Office, Chennai.<br />
                    www.tkstrust.org
                </Typography>

                {/* Right side contact info */}
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        color: "#000",
                        textAlign: { xs: "center", sm: "right" },
                        mt: { xs: 1, sm: 0 }
                    }}
                >
                    📞 +91 9841818740 <br />
                    ✉️ contact@tkstrust.com
                </Typography>








            </Box>
        </Box>
    );
};


export default TKSMemberCard;